var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.type)?_c('div',{staticClass:"stripe-tips"},[_vm._v("Bezahlung erfolgreich!")]):_c('div',{staticClass:"stripe-tips"},[_vm._v("Bezahlung fehlgeschlagen!")])])}
var staticRenderFns = []

export { render, staticRenderFns }